module.exports = __webpack_public_path__ + "static/media/banner-2-novo2-2024.c910de81.jpg";